import React from 'react';

import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import Dialog from '../../../../base/ui/components/web/Dialog';
import { toggleScreenshotCaptureSummary } from '../../../../screenshot-capture';
import { isScreenshotCaptureEnabled } from '../../../../screenshot-capture/functions';
import { RECORDING_TYPES } from '../../../constants';
import AbstractStartRecordingDialog, {
    mapStateToProps as abstractMapStateToProps
} from '../AbstractStartRecordingDialog';

import StartRecordingDialogContent from './StartRecordingDialogContent';

// CUSTOM
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from "../../../../customise/constant";
import { clickAutoMakeHost, setStemRecording } from '../../../../customise/redux/tool-webjam/actions';
import { ValidateEmail, _ValidateIPaddress } from '../../../../customise/welcome-dashboard/Utils';
import { Translate } from '../../../../webjam/language';
import { dispatch, getBaseConfig } from '../../../../customise/Utils';
import { setRecordingEmail, setToolModal, showMixerSettingsModal } from '../../../../customise/redux/tool-webjam-v2/actions';
import toast from 'react-simple-toasts';
import { DialogModal } from '../../../../customise/custom/toolbar/recording-streaming';
import { messagesLabel } from '../../../../customise/welcome-dashboard/messages';
import { Constant, CURRENT_ROOM_NAME } from '../../../../webjam/constant';
import { hideDialog } from '../../../../base/dialog';
import Checkbox from '../../../../base/ui/components/web/Checkbox';
import { ct } from '../../../../customise/constant-Utils';

// END

/**
 * React Component for getting confirmation to start a file recording session in
 * progress.
 *
 * @augments Component
 */
class StartRecordingDialog extends AbstractStartRecordingDialog {

    isStartRecordingDisabled: () => boolean;

    /**
     * Disables start recording button.
     *
     * @returns {boolean}
     */
    isStartRecordingDisabled() {
        const { isTokenValid, selectedRecordingService } = this.state;

        // Start button is disabled if recording service is only shown;
        // When validating dropbox token, if that is not enabled, we either always
        // show the start button or, if just dropbox is enabled, start button
        // is available when there is token.
        if (selectedRecordingService === RECORDING_TYPES.JITSI_REC_SERVICE) {
            return false;
        } else if (selectedRecordingService === RECORDING_TYPES.DROPBOX) {
            return !isTokenValid;
        } else if (selectedRecordingService === RECORDING_TYPES.LOCAL) {
            return false;
        }

        return true;
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */

    // CUSTOM
    componentDidMount() {
        const { dispatch, userLoginData, tokenDecodedData, isUserLogin, clickedAutoMakeHost } = this.props;
        dispatch(setStemRecording(false))

        let u_email = "";

        if (userLoginData) {
            if (userLoginData?.email) {
                u_email = userLoginData.email;
            }
        }

        if (!u_email) {
            if (tokenDecodedData) {
                if (tokenDecodedData?.email) {
                    u_email = tokenDecodedData.email;
                }
            }
        }

        this.setState({
            willEmailModal: false,
            willStartRecModal: true,
            isSubmitted: false,
            inputEmail: u_email
        });



        if (!isUserLogin && !tokenDecodedData) {
            this.setState({
                guestModal: true
            })
        } else {
            this.setState({
                guestModal: false
            })
        }
    }


    componentDidUpdate(prevProps) {
        const { showRecordingModal, enableRecordingModal, isUserLogin, userLoginData, tokenDecodedData } = this.props;
        if (prevProps.showRecordingModal != showRecordingModal) {
            if (showRecordingModal) {
                if (this.state.isSubmitted) {
                    this.setState({
                        willEmailModal: false,
                        willStartRecModal: true,
                    })
                }
            }
        }

        if (prevProps.enableRecordingModal != enableRecordingModal) {
            if (this.state.willStartRecModal == false) {
                this.setState({
                    willStartRecModal: true
                })
            }
        }

        if (prevProps.isUserLogin != isUserLogin || prevProps.tokenDecodedData != tokenDecodedData) {
            if (isUserLogin || tokenDecodedData) {
                this.setState({
                    guestModal: false
                })
            } else {
                this.setState({
                    guestModal: true
                })
            }
        }

        if (prevProps.userLoginData != userLoginData) {
            if (userLoginData) {
                if (userLoginData?.email) {
                    this.setState({
                        inputEmail: userLoginData.email
                    })
                }
            }
        }

    }

    _checkStemRecording(type) {
        const { usersData, dispatch, devicesUsers } = this.props;
        if ((devicesUsers && devicesUsers.isHost) || (usersData && usersData.isHost)) {
            dispatch(setStemRecording(type))
            this.setState({
                checkStemRecord: type
            });
        }
    }

    renderStemRecording() {
        const { roomorIpAddress, devicesUsers, usersData } = this.props;
        const { checkStemRecord } = this.state;

        let isIpAddress = _ValidateIPaddress(roomorIpAddress);

        if (!isIpAddress && ((devicesUsers && devicesUsers.isHost) || (usersData && usersData.isHost)) && getBaseConfig("stemRecording") == true) {

            return (<>
                <div style={{ marginTop: "20px" }}>
                    <Checkbox
                        checked={checkStemRecord}
                        label={ct("Translate.messages.enableStemRecording")}
                        name='enable-stem'
                        id="enable-idividual-track"
                        onChange={() => this._checkStemRecording(!checkStemRecord)}
                    />
                </div>
            </>)
        }
    }

    emailHandler = (value) => {
        const { inputEmail } = this.state;
        const { userLoginData, tokenDecodedData } = this.props;

        if (value == 'submit') {
            let uEmail = inputEmail;
            let willProceed = false;

            if (uEmail) {
                if (!ValidateEmail(uEmail)) {
                    toast(ct("Translate.validations.validEmail"), Constant.App.ToastTime.LongCloseTime)
                } else {
                    willProceed = true;
                }
            } else {
                toast(ct("Translate.validations.emptyEmail"), Constant.App.ToastTime.LongCloseTime)
            }

            if (willProceed) {
                dispatch(setRecordingEmail(uEmail))
                this._onSubmit()
                let u_email = "";

                if (userLoginData) {
                    if (userLoginData?.email) {
                        u_email = userLoginData.email;
                    }
                }

                if (!u_email) {
                    if (tokenDecodedData) {
                        if (tokenDecodedData?.email) {
                            u_email = tokenDecodedData.email;
                        }
                    }
                }

                this.setState({
                    willEmailModal: false,
                    willStartRecModal: false,
                    isSubmitted: true,
                    inputEmail: u_email
                })
                this.props.dispatch(hideDialog())
            }
        }

        if (value == 'skip') {
            this.setState({
                willEmailModal: false,
                willStartRecModal: false,
                isSubmitted: true
            })
        }
    }

    submitLocalRecording = () => {
        const isGuestUserAllowed = getBaseConfig("guestUser");
        const { userLoginData } = this.props;
        if (isGuestUserAllowed) {
            this._onSubmit();
            this.setState({
                willEmailModal: false,
                willStartRecModal: false,
                isSubmitted: true,
            })
        } else {
            this.setState({
                willEmailModal: true,
                willStartRecModal: false,
                isSubmitted: false,
                // inputEmail: ""
            })
        }
    }

    handleLoginModal = (type) => {
        let obj = {
            toolName: "",
            toolType: "",
            componentName: ""
        }

        if (type == "submit") {
            obj = {
                toolName: "signup",
                toolType: "menu-tool",
                componentName: "StartRecordingDialog"
            }
        }

        this.props.dispatch(setToolModal(obj))
        this.props.dispatch(hideDialog())
    }

    handleDisableAMHost = () => {
        this.props.dispatch(hideDialog())
        sessionStorage.setItem("mixer_tab_" + CURRENT_ROOM_NAME, 3)
        this.props.dispatch(showMixerSettingsModal(true))
    }
    // END

    render() {
        const {
            isTokenValid,
            isValidating,
            localRecordingOnlySelf,
            selectedRecordingService,
            sharingEnabled,
            spaceLeft,
            userName,
            // CUSTOM
            willEmailModal,
            willStartRecModal,
            isSubmitted,
            guestModal
            // END
        } = this.state;
        const {
            _fileRecordingsServiceEnabled,
            _fileRecordingsServiceSharingEnabled,
            // CUSTOM
            isRecordingLoader,
            clickedAutoMakeHost,
            usersData
            // END
        } = this.props;

        // CUSTOM
        // disable ok button id recording service is shown only, when validating dropbox token, if that is not enabled we either always show the ok button or if just dropbox is enabled ok is available when there is token
        const isOkDisabled
            = _fileRecordingsServiceEnabled ? isValidating
                : _isDropboxEnabled ? !isTokenValid : false;

        const isGuestUserAllowed = getBaseConfig("guestUser");

        if (guestModal && !isGuestUserAllowed) {
            return <Dialog
                ok={{
                    translationKey: ct("rta-trmc.dialogs.willCompleteIn")
                }}
                cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
                titleKey={ct("rta-trmc.toolBox.startRecording")}
                onSubmit={() => this.handleLoginModal("submit")}
                onCancel={() => this.handleLoginModal("close")}
                width='small'
                testId={isRecordingLoader ? 'submit-recording' : 'start-rec-popup'}
                rtaClassName="start-recording-dialog"
            > {messagesLabel.guestLoginText}</Dialog>
            // return <DialogModal
            //     title="Start Recording"
            //     isHide={false}
            //     onSubmit={() => this.handleLoginModal("submit")}
            //     onClose={() => this.handleLoginModal("close")}
            //     children={<>
            //         <p
            //             style={{
            //                 color: "#333"
            //             }}
            //         >
            //             {messagesLabel.guestLoginText}
            //         </p>
            //     </>}
            //     submitText={"Sign Up"}
            //     testId={'start-rec-more-action'}
            // />
        }

        let noHidepop = true;
        if(isGuestUserAllowed){
            noHidepop = false;
        }

        return (
            <>
                {willStartRecModal && !willEmailModal &&
                    clickedAutoMakeHost && usersData && !_ValidateIPaddress(CURRENT_ROOM_NAME)
                    ?
                    <Dialog
                        okDisabled={this.isStartRecordingDisabled()}
                        ok={{
                            translationKey: ct("Translate.buttonTitle.okSmall")
                        }}
                        onSubmit={this.handleDisableAMHost}
                        titleKey='dialog.startRecording'
                        width='small'
                        testId={isRecordingLoader ? 'submit-recording' : 'start-rec-popup'}
                    >
                        <label>
                            {ct("Translate.recording.autoHostEnabledRecording")}
                        </label>
                    </Dialog>
                    :

                    <Dialog
                        ok={{
                            translationKey: 'dialog.startRecording',
                            disabled: this.isStartRecordingDisabled()
                        }}
                        titleKey='dialog.startRecording'
                        disableAutoHideOnSubmit={noHidepop}
                        onSubmit={this.submitLocalRecording}
                        disableBackdropClose={true} // CUSTOM
                        width='small'
                        testId={isRecordingLoader ? 'submit-recording' : 'start-rec-popup'}
                        rtaClassName="start-recording-dialog"
                    // END
                    >
                        <StartRecordingDialogContent
                            fileRecordingsServiceEnabled={_fileRecordingsServiceEnabled}
                            fileRecordingsServiceSharingEnabled={_fileRecordingsServiceSharingEnabled}
                            integrationsEnabled={this._areIntegrationsEnabled()}
                            isTokenValid={isTokenValid}
                            isValidating={isValidating}
                            localRecordingOnlySelf={localRecordingOnlySelf}
                            onChange={this._onSelectedRecordingServiceChanged}
                            onLocalRecordingSelfChange={this._onLocalRecordingSelfChange}
                            onSharingSettingChanged={this._onSharingSettingChanged}
                            selectedRecordingService={selectedRecordingService}
                            sharingSetting={sharingEnabled}
                            spaceLeft={spaceLeft}
                            userName={userName} />
                        {/* CUSTOM */}
                        {
                            this.renderStemRecording()
                        }

                    </Dialog>
                }
                {
                    !willStartRecModal && willEmailModal && !isSubmitted &&
                    <Dialog
                        successBtnId="submit-and-continue-button"
                        okKey='Submit and Continue'
                            ok={{ translationKey: ct("rta-trmc.dialogs.submitAndContinue"), id: 'submit-email-btn' }}
                            cancel={{ translationKey: ct("Translate.buttonTitle.cancelSmall"), id: 'close-email-dialog-btn' }}
                        onSubmit={() => this.emailHandler('submit')}
                        disableAutoHideOnSubmit={true}
                            disableBackdropClose={true} // CUSTOM
                        titleKey='dialog.startRecording'
                        width='small'
                        // cancelKey='Cancel'
                        // onCancel={() => this.emailHandler('skip')}
                        testId={isRecordingLoader ? 'submit-recording' : 'submit-email'}
                    >
                        <label>
                                {ct("rta-trmc.dialogs.recordingLabel")}
                        </label>
                        <input
                            name='email'
                            type="email"
                                placeholder={ct("rta-trmc.dialogs.enterEmail")}
                            defaultValue={this.state.inputEmail}
                            onChange={(event) => this.setState({ inputEmail: event.target.value })}
                        />
                    </Dialog>
                }
            </>
            // END
        );
    }

    /**
     * Toggles screenshot capture feature.
     *
     * @returns {void}
     */
    _toggleScreenshotCapture() {
        const { dispatch, _screenshotCaptureEnabled } = this.props;

        if (_screenshotCaptureEnabled) {
            dispatch(toggleScreenshotCaptureSummary(true));
        }
    }

    _areIntegrationsEnabled: () => boolean;
    _onSubmit: () => boolean;
    _onSelectedRecordingServiceChanged: (string) => void;
    _onSharingSettingChanged: () => void;
    _onLocalRecordingSelfChange: () => void;
}

/**
 * Maps redux state to component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    return {
        ...abstractMapStateToProps(state),
        _screenshotCaptureEnabled: isScreenshotCaptureEnabled(state, true, false),
        // CUSTOM
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        stemRecording: state[FEATURE_CUSTOM_REDUX].stemRecording,
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        devicesUsers: state[FEATURE_CUSTOM_REDUX].devicesUsers,
        isRecordingLoader: state[FEATURE_CUSTOM_REDUX_V2].isRecordingLoader,
        userLoginData: state[FEATURE_CUSTOM_REDUX].userLoginData,
        tokenDecodedData: state[FEATURE_CUSTOM_REDUX].tokenDecodedData,
        showRecordingModal: state[FEATURE_CUSTOM_REDUX_V2].showRecordingModal,
        enableRecordingModal: state[FEATURE_CUSTOM_REDUX_V2].enableRecordingModal,
        isUserLogin: state[FEATURE_CUSTOM_REDUX].isUserLogin,
        clickedAutoMakeHost: state[FEATURE_CUSTOM_REDUX].clickedAutoMakeHost,
        // END
    };
}

export default translate(connect(mapStateToProps)(StartRecordingDialog));
